// Pure helpers for the ChatGPT-subscription switch modal, split out so they can
// be unit-tested without a DOM. Mirrors telegramSetup.ts.

// Device codes issued by OpenAI live ~15 minutes. We count down from 14 so the
// customer is nudged to refresh before the code silently stops working — an
// expired code fails with a generic message on OpenAI's side, which reads as
// "this is broken" rather than "get a new one".
export const CODE_TTL_SECONDS = 14 * 60;

// Applying the cutover RESTARTS the instance, so a brief window where it cannot
// answer is the expected path rather than a failure. Hold the confirm button for
// long enough that a retry cannot pile more work onto a box that is already
// restarting: on 2026-08-19 each impatient press cost it another 18-26s of CPU.
export const RETRY_COOLDOWN_SECONDS = 15;

// How often to ask the instance what it is actually running on while a cutover
// settles. A cold gateway boot is ~60s, so this answers well before the customer
// would think to retry.
export const APPLYING_POLL_MS = 5000;

// And when to stop asking. A cutover that genuinely failed on the box will never
// land, and a poll with no end leaves the modal saying "this page will finish on
// its own" forever while it keeps spending ~27s reads on the instance. Four
// minutes is well past a cold gateway boot plus the deferral behind in-flight
// work, so reaching it means something is actually wrong.
export const APPLYING_TIMEOUT_MS = 4 * 60 * 1000;

export const formatCountdown = (seconds: number): string => {
  // Never render a negative clock: the caller stops ticking at zero, but a
  // backgrounded tab can resume with a stale value.
  const safe = Math.max(0, Math.floor(seconds));
  const m = Math.floor(safe / 60);
  const s = safe % 60;
  return `${m}:${s.toString().padStart(2, "0")}`;
};

// The verification URL is scraped off the instance's login transcript, so it is
// text we did not author — never let a malformed one throw inside render and
// blank the whole modal.
export const hostOf = (url: string): string => {
  try {
    return new URL(url).host;
  } catch {
    return "the ChatGPT sign-in page";
  }
};
